export default __webpack_public_path__ + "static/zhi-4-fe3178f1abaaa4543d9072a9b7838a59.jpg";